import React, { useState, useEffect } from 'react';
import { useApi } from '../../apiHelpers';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Panel from '../../components/ui/Panel';
import { ListStack, ListRow } from '../../components/ui/ListRow';
import { Skeleton, SkeletonGroup } from '../../components/ui/Skeleton';
import FadeIn from '../../components/ui/FadeIn';

dayjs.extend(relativeTime);

const TeamActivityModule = () => {
  const api = useApi();
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await api.get('/maintenance/recent/all', { silent: true });
        setActivity((data || []).slice(0, 10));
      } catch { /* silent */ }
      setLoading(false);
    };
    fetch();
  }, []);

  if (loading) {
    return (
      <Panel title="Team Activity" titleStyle="section" accent="primary" level={3}>
        <SkeletonGroup label="Loading team activity" className="space-y-2">
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
        </SkeletonGroup>
      </Panel>
    );
  }

  if (activity.length === 0) return null;

  return (
    <Panel title="Team Activity" titleStyle="section" accent="primary" lit level={3}>
      <FadeIn>
      <ListStack
        label="Team activity"
        on="panel"
        items={activity}
        getKey={(item) => `${item.drone_serial}-${item.last_touched}-${item.last_action}`}
        renderRow={(item) => (
          <ListRow
            to={`/drone/${item.drone_serial}`}
            leading={(
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-700">
                <span className="text-[10px] font-bold text-on-surface-variant uppercase">
                  {item.firstname?.[0] || '?'}
                </span>
              </span>
            )}
            title={`${item.firstname} touched ${item.drone_serial?.slice(-6)}`}
            meta={item.last_action}
            trailing={<span className="text-xs text-on-surface-variant whitespace-nowrap">{dayjs(item.last_touched).fromNow()}</span>}
          />
        )}
      />
      </FadeIn>
    </Panel>
  );
};

export default TeamActivityModule;
